// extracted by mini-css-extract-plugin
module.exports = {"item":"TerminalOrder_item__1IA8L","image":"TerminalOrder_image__2XMc4","title":"TerminalOrder_title__BL4wx","description":"TerminalOrder_description__3iTij"};